import { jsx as _jsx } from "react/jsx-runtime";
import { toast, Slide } from "react-toastify";
import ErrorToastContent from "./ErrorToastContent";
import { stliteStyledPromiseToast } from "./promise";
export function makeToastKernelEventListeners() {
    let prevToastId = null;
    const toastIds = [];
    const onLoadProgress = (e) => {
        const id = toast(e.detail, {
            position: "bottom-right",
            transition: Slide,
            isLoading: true,
            hideProgressBar: true,
            closeButton: false,
        });
        toastIds.push(id);
        if (prevToastId) {
            toast.update(prevToastId, {
                isLoading: false,
                autoClose: 3000,
            });
        }
        prevToastId = id;
    };
    const onLoadFinished = () => {
        toastIds.forEach((id) => toast.dismiss(id));
    };
    const onLoadError = (e) => {
        toast(_jsx(ErrorToastContent, { message: "Error during booting up", error: e.detail }), {
            position: "bottom-right",
            type: "error",
            autoClose: false,
            closeOnClick: false,
        });
    };
    const onModuleAutoLoad = (e) => {
        const { promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            success: {
                render({ data }) {
                    return `Auto-loaded${data ? ": " + data.map((pkg) => pkg.name).join(", ") : " packages"}`;
                },
            },
            error: "Failed to auto-load packages",
            pending: "Auto-loading packages",
        });
    };
    const onInstall = (e) => {
        const { requirements, promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            pending: "Installing",
            success: `Successfully installed: ${requirements.join(", ")}`,
            error: `Failed to install: ${requirements.join(", ")}`,
        });
    };
    const onWriteFile = (e) => {
        const { path, promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            error: `Failed to write file: ${path}`,
        });
    };
    const onRenameFile = (e) => {
        const { oldPath, newPath, promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            error: `Failed to rename file from ${oldPath} to ${newPath}`,
        });
    };
    const onUnlink = (e) => {
        const { path, promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            error: `Failed to unlink: ${path}`,
        });
    };
    const onReadFile = (e) => {
        const { path, promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            error: `Failed to read file: ${path}`,
        });
    };
    const onReboot = (e) => {
        const { promise } = e.detail;
        stliteStyledPromiseToast(promise, {
            pending: "Rebooting",
            success: "Successfully rebooted",
            error: "Failed to reboot",
        });
    };
    return {
        onLoadProgress,
        onLoadFinished,
        onLoadError,
        onModuleAutoLoad,
        onInstall,
        onWriteFile,
        onRenameFile,
        onUnlink,
        onReadFile,
        onReboot,
    };
}
//# sourceMappingURL=callbacks.js.map